import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from '../styles.module.scss';

const ProgressBar = ({
	reference,
	onChangeCallback,
	initialValue,
	rewindForward,
	rewindBack,
	theme
}) => {
	// eslint-disable-next-line consistent-return
	const handleChange = (event) => {
		if (rewindForward && rewindBack) {
			switch (event.code) {
				case 'ArrowLeft':
					return rewindBack(event);
				case 'ArrowRight':
					return rewindForward(event);
				default:
					return '';
			}
		}
	};

	const disableMobileScrolling = () => {
		document.body.style.overflow = 'hidden';
	};
	const enableMobileScrolling = () => {
		document.body.style.overflow = '';
	};

	return (
		<div className={styles.ProgressBar}>
			<input
				type="range"
				className={cx(
					styles.ProgressBar__Control,
					styles[`ProgressBar__Control_theme_${theme}`]
				)}
				defaultValue={initialValue || 0}
				ref={reference}
				onChange={onChangeCallback}
				onKeyDown={handleChange}
				onTouchStart={disableMobileScrolling}
				onTouchEnd={enableMobileScrolling}
			/>
		</div>
	);
};

ProgressBar.propTypes = {
	reference: PropTypes.object,
	onChangeCallback: PropTypes.func.isRequired,
	initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	rewindForward: PropTypes.func,
	rewindBack: PropTypes.func,
	theme: PropTypes.oneOf(['light'])
};

export default ProgressBar;
